<template>
  <div class="ms-header" :class="{'is-mobile': isMobile}">
    <div class="ms-bar">
      <div class="wrap inner">
        <div class="logo-box" v-if="!isMobile">
          <img src="@/assets/images/logo.png" class="logo" alt="">
        </div>
        <div class="bar-box ms-flex-middle-between" :style="{'padding-bottom': !isLogin ? '0px' : '30px'}">
          <div class="welcome-txt">Hi  您好!欢迎来到中马中联金！! </div>
          <div class="right-bar ms-flex-middle">
            <!-- <div class="entrance-box ms-flex-middle">
              <div class="entrance-item pointer">帮助中心</div>
              <div class="entrance-item pointer" @click="setHome">设为首页</div>
              <div class="entrance-item pointer" @click="addFavorite">添加收藏</div>
            </div> -->
            <div class="service-phone">服务热线：400-138-1308</div>
            <div class="user-center ms-flex-middle pointer" @click="$router.push('/userCenter/index')" v-if="!!isLogin">
              <div class="el-icon-user-solid"></div>
              <div class="text">个人中心</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ms-navbar">
      <div class="logo-box" v-if="!!isMobile">
        <img src="@/assets/images/logo.png" class="logo" alt="">
      </div>
      <div class="wrap" :style="{'min-width': !isMobile ? '1080px' : '320px'}" :class="[!isMobile ? 'ms-flex-middle' : 'ms-flex-middle-between']">
        <div class="menu ms-flex-middle" v-if="!isMobile">
          <div :class="{active: $route.path == '/' || $route.path == '/home'}" class="menu-item textE" @click="$router.push('/')">首页</div>
          <template v-for="menu in menuList.filter((item, index) => index < 6)">
            <el-popover
              placement="bottom-start"
              :visible-arrow="false"
              width="200px"
              trigger="hover"
              popper-class="popper-navbar"
              v-if="(menu.children || []).filter(item => item.display == 1).length > 0"
              :key="menu.id"
              >
              <second-navbar :menu="menu" />
              <div slot="reference" :class="{active: $route.params.channelId == menu.id}" class="menu-item textE" @click="handleClick(menu)">{{ menu.name }}</div>
            </el-popover>
            <div :key="menu.id" v-else :class="{active: $route.params.channelId == menu.id}" class="menu-item textE" @click="handleClick(menu)">{{ menu.name }}</div>
          </template>
        </div>
        <div class="menu" v-else>
          <el-popover placement="bottom-end" width="300" trigger="click" v-model="visible">
            <el-menu class="el-menu-vertical-demo" unique-opened>
              <el-menu-item index="home" @click="handleHome">
                <span slot="title">首页</span>
              </el-menu-item>
              <template v-for="(menu, index) in menuList.filter((item, index) => index < 6)">
                <el-submenu :index="'' + menu.id" :key="menu.id" v-if="(menu.children || []).filter(item => item.display == 1).length > 0" @click="handleMenuClick(menu)">
                  <template slot="title">
                    <span>{{ menu.name }}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item :index="'' + item.id" v-for="item in (menu.children || []).filter(item => item.display == 1)" :key="item.id" @click="handleMenuClick(item)">{{ item.name }}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item :index="'' + menu.id" :key="menu.id" v-else @click="handleMenuClick(menu)">
                  <span slot="title">{{ menu.name }}</span>
                </el-menu-item>
              </template>
            </el-menu>
            <div class="el-icon-menu" slot="reference"></div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondNavbar from './SecondNavbar.vue'
import { mapGetters } from 'vuex'
import { companyApplyStatus } from '@/api/index'
export default {
  name: 'MsNavbar',
  components: { SecondNavbar },
  data() {
    return {
      applyLoading: false,
      visible: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'isLogin']),
    menuList() {
      let menus = this.$store.getters.menus || []
      return menus.filter(item => item.display == 1)
    }
  },
  methods: {
    handleLogin() {
      this.$router.push('/login')
    },
    handleRegister() {
      this.$router.push('/register')
    },
    handleHome() {
      this.visible = false
      this.$router.push('/')
    },
    handleLogout() {
      this.$confirm('This operation will log out. Do you want to continue?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('user/logout').then(() => {
          this.$message({
            type: 'success',
            message: 'logout success!'
          });
          this.$router.push('/home')
        })
      }).catch(() => {});
    },
    handleNameClick() {
      if(this.applyLoading) return
      this.applyLoading = true
      companyApplyStatus().then(res => {
        let result = res.data || {applyStatus: 0}
        if(!result.applyStatus) {
          this.$router.push('/register?current=3')
        } else {
          this.$router.push(`/registerInfo?applyId=${result.applyId}`)
        }
        this.applyLoading = false
      }).catch(err => {
        this.applyLoading = false
      })
    },
    handleMenuClick(item) {
      this.visible = false
      this.handleClick(item)
    },
    
    //加入收藏
    addFavorite() {
      let url = location.href
      let sURL =encodeURI(url);
      try{
        window.external.addFavorite(sURL, '222');
      }catch(e) {
        try{
          window.sidebar.addPanel('222', sURL, "");
         }catch (e){
          alert("您的浏览器不支持自动加入收藏功能，请使用Ctrl+D进行添加，或手动在浏览器里进行设置！");
        }
      }
    },

    //设为首页
    setHome(){
      let url = location.href
      if (document.all) {
        document.body.style.behavior="url(#default#homepage)";
        document.body.setHomePage(url);
      }else{
        alert("您的浏览器不支持自动设置页面为首页功能，请您手动在浏览器里设置该页面为首页！");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ms-bar {
  background: #1F36C7;
  .inner {
    position: relative;
    box-sizing: border-box;
    padding-left: 275px;
    height: 30px;
  }
  .logo-box {
    width: 240px;
    height: 110px;
    background: #FFF;
    box-sizing: border-box;
    padding: 5px 14px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    .logo {
      width: 212px;
      height: auto;
    }
  }
  .bar-box {
    .welcome-txt {
      height: 30px;
      font-size: 12px;
      color: #C0D7FF;
      line-height: 30px;
    }
    .right-bar {
      .entrance-box {
        .entrance-item {
          height: 12px;
          font-size: 12px;
          color: #C0D7FF;
          line-height: 12px;
          box-sizing: border-box;
          padding: 0 16px;
          border-right: 1px solid #C0D7FF;
          &:last-child {
            border-right: none;
          }
        }
      }
      .service-phone {
        height: 30px;
        font-size: 12px;
        color: #C0D7FF;
        line-height: 30px;
        margin-left: 30px;
      }
      .user-center {
        height: 30px;
        font-weight: bold;
        font-size: 12px;
        color: #FFF;
        line-height: 30px;
        margin-left: 70px;
        .text {
          margin-left: 8px;
        }
      }
    }
  }
}
.ms-navbar {
  background: #005EFF;
  height: 96px;
  position: relative;
  .wrap {
    position: relative;
    padding-left: 275px;
    box-sizing: border-box;
  }
  .menu {
    flex: 1;
    .menu-item,
    & > span {
      position: relative;
      font-size: 16px;
      height: 96px;
      line-height: 96px;
      max-width: 15rem;
      cursor: pointer;
      color: #fff;
      font-weight: 600;
      min-width: 100px;
      text-align: center;
      flex: 1;
      &:hover,
      &.active {
        position: relative;
        &::after {
          position: absolute;
          content: "";
          display: block;
          width: 75px;
          height: 3px;
          background: #1F36C7;
          left: 50%;
          transform: translateX(-50%);
          bottom: 20px;
        }
      }
    }
  }
}
.is-mobile {
  .ms-bar {
    .inner {
      position: relative;
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 15px;
      height: auto;
    }
    .bar-box {
      position: relative;
      .welcome-txt {
        height: 30px;
        font-size: 12px;
        color: #C0D7FF;
        line-height: 30px;
      }
      .right-bar {
        .entrance-box {
          .entrance-item {
            height: 12px;
            font-size: 12px;
            color: #C0D7FF;
            line-height: 12px;
            box-sizing: border-box;
            padding: 0 16px;
            border-right: 1px solid #C0D7FF;
            &:last-child {
              border-right: none;
            }
          }
        }
        .service-phone {
          height: 30px;
          font-size: 12px;
          color: #C0D7FF;
          line-height: 30px;
          margin-left: 30px;
        }
        .user-center {
          height: 30px;
          font-weight: bold;
          font-size: 12px;
          color: #FFF;
          line-height: 30px;
          margin-left: 70px;
          position: absolute;
          bottom: 0;
          right: 15px;
          .text {
            margin-left: 8px;
          }
        }
      }
    }
  }
  .ms-navbar {
    .logo-box {
      width: 120px;
      height: 55px;
      background: #FFF;
      box-sizing: border-box;
      padding: 5px 14px;
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 2;
      .logo {
        width: 106px;
        height: auto;
      }
    }
    .wrap {
      position: relative;
      padding-left: 275px;
      box-sizing: border-box;
    }
    .menu {
      flex: 1;
      .menu-item,
      & > span {
        position: relative;
        font-size: 16px;
        height: 96px;
        line-height: 96px;
        max-width: 15rem;
        cursor: pointer;
        color: #fff;
        font-weight: 600;
        min-width: 100px;
        text-align: center;
        flex: 1;
        &:hover,
        &.active {
          position: relative;
          &::after {
            content: none;
          }
        }
      }
      .el-icon-menu {
        font-size: 40px;
      }
    }
  }
}
</style>